// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"ff623ca9","453":"c19b0c40","583":"35e13aa0","805":"f80a7c37","936":"25f364e0"}[chunkId] + ".chunk.js";
};